import './App.css';
import React, { useEffect } from "react";
import Page from "./components/Page";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { initialState, reducer } from "./data/reducer";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { useAuth, hasAuthParams } from "react-oidc-context";

export default function App() {
    const auth = useAuth();

    // trigger sso when the page loads and stop it from looping
    useEffect(() => {
        if (auth.isLoading || auth.isAuthenticated || auth.activeNavigator || auth.error || hasAuthParams()) {
            return;
        }

        void auth.signinRedirect();
    }, [auth, auth.isLoading, auth.isAuthenticated, auth.activeNavigator, auth.error, auth.signinRedirect]);

    const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(thunk)));
    return (

        <Provider store={store}>
            <Page auth={auth}/>
        </Provider>
    );
}